import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { LuxIcon } from '@lux/wardrobe-lib'
import { ActionProps } from '@/app/models/action'
import { isMobileChecker } from '@/app/utils/commonFunctions'
import './ActionCard.scss'

const ActionCard = (props: ActionProps) => {
    const { title, count, progress, onClick, taskCreationDate } = props

    const componentClass = 'smart-modals-action-card'

    const intl = useIntl()

    const isMobile = isMobileChecker()

    const [dateCheck, setDateCheck] = useState(true)
    const [status, setStatus] = useState('')

    useEffect(() => {
        if (!dateCheck) {
            if (progress < 100) {
                setStatus('not_completed')
            } else {
                setStatus('completed')
            }
        }
    }, [dateCheck])

    useEffect(() => {
        if (taskCreationDate?.length > 0) {
            taskCreationDate?.map((item) => {
                if (new Date().getTime() >= new Date(item.startDate).getTime()) {
                    if (progress < 100) {
                        setStatus('not_completed')
                    } else {
                        setStatus('completed')
                    }
                } else {
                    setDateCheck(false)
                }
            })
        } else {
            if (progress < 100) {
                setStatus('not_completed')
            } else {
                setStatus('completed')
            }
        }
    }, [taskCreationDate, progress])

    return (
        <div className={componentClass} onClick={onClick}>
            <div className={`${componentClass}__bar`}>
                <div
                    data-progress={progress}
                    style={{ width: `${dateCheck ? progress : progress > 0 ? progress : 0}%` }}
                    className={`${componentClass}__bar__progress`}
                />
            </div>
            <div className={`${componentClass}__row`}>
                <div className={`${componentClass}__title`}>{title}</div>

                <div className={`${componentClass}__content`}>
                    <div className={`${componentClass}__content__label`}>
                        {intl.formatMessage({
                            id: 'modals.news_execution.action.action_card.content',
                            defaultMessage: 'Content',
                        })}
                    </div>
                    <div className={`${componentClass}__content__value`}>{`${count} ${title}`}</div>
                </div>
                <div className={`${componentClass}__status`}>
                    <div className={`${componentClass}__status__label`}>
                        {intl.formatMessage({
                            id: 'modals.news_execution.action.action_card.status',
                            defaultMessage: 'Status',
                        })}
                    </div>
                    <div className={`${componentClass}__status__value`}>
                        {intl.formatMessage({
                            id: `modals.news_execution.action.action_card.status.${status}`,
                            defaultMessage: status,
                        })}
                        <LuxIcon
                            icon={status === 'completed' ? 'check' : 'times'}
                            classes={status}
                        />
                    </div>
                </div>
                <div className={`${componentClass}__arrow`} onClick={onClick}>
                    <LuxIcon icon="caret-right" />
                </div>
            </div>
            {isMobile && (
                <div className={`${componentClass}__row`} style={{ alignItems: 'flex-end' }}>
                    <div className={`${componentClass}__content`}>
                        <div className={`${componentClass}__content__label`}>
                            {intl.formatMessage({
                                id: 'modals.news_execution.action.action_card.content',
                                defaultMessage: 'Content',
                            })}
                        </div>
                        <div
                            className={`${componentClass}__content__value`}>{`${count} ${title}`}</div>
                    </div>
                    <div className={`${componentClass}__status`}>
                        <div className={`${componentClass}__status__label`}>
                            {intl.formatMessage({
                                id: 'modals.news_execution.action.action_card.status',
                                defaultMessage: 'Status',
                            })}
                        </div>
                        <div className={`${componentClass}__status__value`}>
                            {intl.formatMessage({
                                id: `modals.news_execution.action.action_card.status.${status}`,
                                defaultMessage: status,
                            })}
                            <LuxIcon
                                icon={status === 'completed' ? 'check' : 'times'}
                                classes={status}
                            />
                        </div>
                    </div>
                    <div className={`${componentClass}__arrow`} onClick={onClick}>
                        <LuxIcon icon="caret-right" />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ActionCard
